// Generic search input row for a chat: text field + submit + close. Submits on
// Enter, closes on Escape. Purely presentational; state lives in useMessageSearch.
function SearchBar({ query, onQueryChange, onSubmit, onClose, loading, placeholder = 'Search messages' }) {
  return (
    <div className="chat-search-bar">
      <input
        autoFocus
        className="chat-search-input"
        value={query}
        placeholder={placeholder}
        onChange={(e) => onQueryChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            onSubmit()
          } else if (e.key === 'Escape') {
            onClose()
          }
        }}
      />
      <button
        type="button"
        className="chat-search-go"
        onClick={onSubmit}
        disabled={loading || !query.trim()}
        title="Search"
        aria-label="Search"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="7" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </button>
      <button
        type="button"
        className="chat-search-close"
        onClick={onClose}
        title="Close search"
        aria-label="Close search"
      >
        &times;
      </button>
    </div>
  )
}

export default SearchBar
